__turbopack_context__.v({
  "areaPageV2Typography": "style-module-scss-module__gLLzgG__areaPageV2Typography",
  "blur-image": "style-module-scss-module__gLLzgG__blur-image",
  "component": "style-module-scss-module__gLLzgG__component",
  "favourite": "style-module-scss-module__gLLzgG__favourite",
  "image": "style-module-scss-module__gLLzgG__image",
  "image-container": "style-module-scss-module__gLLzgG__image-container",
  "price-time": "style-module-scss-module__gLLzgG__price-time",
  "provider-label": "style-module-scss-module__gLLzgG__provider-label",
  "provider-logo": "style-module-scss-module__gLLzgG__provider-logo",
  "provider-logo-container": "style-module-scss-module__gLLzgG__provider-logo-container",
  "right": "style-module-scss-module__gLLzgG__right",
  "street-address": "style-module-scss-module__gLLzgG__street-address",
  "street-address-link": "style-module-scss-module__gLLzgG__street-address-link",
  "text": "style-module-scss-module__gLLzgG__text",
});
